import { Logger } from 'vue-infra';
// import merge from 'lodash/merge';
// import defaultConf from '../config/default-conf';
import routes from './router/routes';
import { appCode, appName } from '../config';
import { loadI18nResources } from './i18n/resource-resolver';

import AppComponent from './App.vue';

const appStore = () => import('./store/store');

const logger = Logger.getLogger(`${appName}:main`);

// fixme - add instructions for every prop
const config = {
  id: appName,
  keepDOMRendered: false, // true -> use v-show instead of v-if in the application renderer
  moduleName: appName,
  routePrefix: appCode,
  // todo - don't just pass any persona
  personaMapping: appName,
  // todo - try passing ['*']
  personas: ['agent', 'messagingAgent', 'marketer', 'guest', 'admin', 'agentManager', appName],
  switcher: {
    // fixme (LE) - provide fallback in case this is not set
    control: `switcher-item-${appCode}`,
    fontIconName: 'ico-configuration', // icon for the navigation menu.
    // fixme (LE) - provide fallback in case this is not set
    index: 999999,
    // todo - try these
    titleTranslationKey: 'common.general.title',
    tooltipTranslationKey: 'common.general.title',
    // iconClass: 'ico-16 ico-switcher-item-automation-platform',
  },
};

const canInitialize = (leAppConfig) => {
  // if (leAppConfig.config) {
  //   merge(defaultConf, leAppConfig.config);
  //   // defaultConf = { ...defaultConf, ...leAppConfig.config };
  // }
  // Validate here if the module should be loaded. For example, check AC Features, User Permissions, etc.
  return true;
};

const applicationInit = async (leAppConfig) => {
  if (!canInitialize(leAppConfig)) {
    return {};
  }

  const i18nResources = await loadI18nResources(leAppConfig.locale, leAppConfig.fallbackLocale);

  appStore()
    .then(() => {
    })
    .catch((err) => logger.info('Failed to load the store', err));

  return {
    vueComponent: AppComponent,
    appId: appCode,
    routes,
    ...i18nResources,
  };
};

const webpackPathInit = (leAppConfig) => {
  __webpack_public_path__ = leAppConfig.publicPath;
};

export default {
  config,
  applicationInit,
  webpackPathInit,
};
